import React from 'react'
import { useTranslation } from 'react-i18next'
import { useFormContext } from 'react-hook-form'
import { FormFields } from '~/components/FormFields'
import i18n from '~/components/i18n'
import { StyledTabWrapper } from '../style'
import InfoPopup from '~/components/InfoPopup'

const getCheckBoxItems = () => [
  {
    label: i18n.t('Is supplier number unique?'),
    name: 'supplierNoUnique',
    info:
      i18n.t('Is the supplier number a one-to-one ID or are you using internal IDs? In case you are using internal IDs supplier numbers can be changed automatically e.g. through imports.')
  },
  {
    label: i18n.t('Show mobile number on user activation?'),
    name: 'showMobileOnVerification',
    info: i18n.t('Show the farmers mobile number during the activation process?')
  },
  {
    label: i18n.t('Enable automated email notifications?'),
    name: 'farmersEmailsStatus',
    info:
      i18n.t('Do you want to activate automated e-mail notifications? When clicking on "No" no automated e-mails will be sent to the farmers any longer.')
  },
  {
    label: i18n.t('Operative users can see farmer information?'),
    name: 'operativeUsersCanSeeFarmersInfo'
  },
  {
    label: i18n.t('Allow only Chrome, Edge, Firefox and Safari browsers?'),
    name: 'blockBrowsers'
  }
]

interface GeneralInformationProps {
  languageOptions: any[]
}

const GeneralInformation: React.FunctionComponent<GeneralInformationProps> = (props) => {
  const { control } = useFormContext()
  const { t } = useTranslation()
  const checkBoxItems = getCheckBoxItems()

  function getLabel(item) {
    return <label style={{ display: 'flex', alignItems: 'baseline' }}>
      <div>{item.label}</div>
      {item.info && <InfoPopup
        content={item.info}
        styleIcon={{ cursor: 'pointer', marginLeft: 3, fontSize: '1.2em' }}
      />
      }
    </label>
  }

  function renderForm() {
    return <>
      {checkBoxItems.map(item => {
        return <FormFields.Checkbox
          key={item.name}
          control={control}
          name={item.name}
          id={item.name}
          defaultValue={0}
          checkboxValue={1}
          label={getLabel(item)}
        />
      })}
      <FormFields.Select
        control={control}
        style={{ width: '25%' }}
        name={'languageId'}
        selectOnBlur={false}
        options={props.languageOptions}
        label={getLabel({
          label: t('Default language'),
          info: t('Please select the standard (default) language for this platform.')
        })}
        selection
      />
    </>
  }

  return <StyledTabWrapper>
    {renderForm()}
  </StyledTabWrapper>
}
export default GeneralInformation
